import React from 'react';
import PropTypes from 'prop-types';

const Facebook = props => {
  const { id, ...rest } = props;

  return (
    <svg
      id={id}
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M17.964 7c.598 0 .997-.4.997-1V2c0-.6-.399-1-.997-1h-2.991C11.683 1 8.99 3.7 8.99 7v2H6.997C6.399 9 6 9.4 6 10v4c0 .6.399 1 .997 1h1.994v7c0 .6.399 1 .997 1h3.988c.598 0 .997-.4.997-1v-7h1.994c.498 0 .897-.3.997-.8l.997-4c.1-.3 0-.6-.2-.9-.199-.3-.498-.3-.797-.3h-2.991V7h2.99zm-3.988 4h2.692l-.499 2h-2.193c-.598 0-.997.4-.997 1v7h-1.994v-7c0-.6-.399-1-.997-1H7.994v-2h1.994c.598 0 .997-.4.997-1V7c0-2.2 1.795-4 3.988-4h1.994v2h-1.994c-1.097 0-1.994.9-1.994 2v3c0 .6.399 1 .997 1z"
        id={`${id}-path`}
      />
    </svg>
  );
};

Facebook.propTypes = {
  id: PropTypes.string,
};

Facebook.defaultProps = {
  id: 'facebook',
};

export default Facebook;
